import { render, staticRenderFns } from "./StatementMoreStore.vue?vue&type=template&id=d1a60bde&scoped=true&"
import script from "./StatementMoreStore.vue?vue&type=script&lang=js&"
export * from "./StatementMoreStore.vue?vue&type=script&lang=js&"
import style0 from "./StatementMoreStore.vue?vue&type=style&index=0&id=d1a60bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a60bde",
  null
  
)

export default component.exports